import React, { useEffect } from 'react';
import { Modal, Form, Input, Radio, Select } from 'antd';
import type { TeamAuditConfigEntity } from '../../../types/team/team_audit_config';

interface TeamAuditConfigUpsertModalProps {
  visible: boolean;
  onCancel: () => void;
  onSave: (values: Partial<TeamAuditConfigEntity>) => Promise<void>;
  initialValues: TeamAuditConfigEntity | null;
  isDefaultField?: boolean;
}

const TeamAuditConfigUpsertModal: React.FC<TeamAuditConfigUpsertModalProps> = ({
  visible,
  onCancel,
  onSave,
  initialValues,
  isDefaultField,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (initialValues) {
        form.setFieldsValue({
          fieldName: initialValues.fieldName,
          fieldType: initialValues.fieldType || 'text',
          description: initialValues.description,
          isRequired: initialValues.isRequired,
        });
      } else {
        form.resetFields();
        form.setFieldsValue({ isRequired: true, fieldType: 'text' }); // Default values
      }
    }
  }, [visible, initialValues, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await onSave(values);
    } catch (e) {
      // Validation failed
    }
  };

  return (
    <Modal
      title={isDefaultField ? '编辑审核项' : (initialValues ? '编辑审核项' : '新增审核项')}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="确定"
      cancelText="取消"
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item 
          name="fieldName" 
          label="审核项名称" 
          rules={[{ required: true, message: '请输入审核项名称' }]}
        >
          <Input 
            placeholder="例如：身份证正反面" 
            disabled={!!isDefaultField} 
          />
        </Form.Item>
        <Form.Item 
          name="fieldType" 
          label="字段类型" 
          rules={[{ required: true, message: '请选择字段类型' }]}
        >
          <Select disabled={!!isDefaultField}>
            <Select.Option value="text">文本</Select.Option>
            <Select.Option value="upload">上传</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item 
          name="description" 
          label="说明要求" 
        >
          <Input.TextArea 
            rows={4} 
            placeholder="请输入审核人员在核对该项时需要注意的具体要求..." 
          />
        </Form.Item>
        <Form.Item 
          name="isRequired" 
          label="是否必填" 
          rules={[{ required: true, message: '请选择是否必填' }]}
        >
          <Radio.Group>
            <Radio value={true}>必填</Radio>
            <Radio value={false}>选填</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TeamAuditConfigUpsertModal;